module.exports = __webpack_public_path__ + "static/media/281043_Search_R_orange.ddf4dcbb.png";